import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LayoutContext from '../../../store/Layout/contexts';
import AppContext from '../../../store/App/contexts';
import { GET, newFetch } from '../../../helpers/fetch';
import { orderBy } from 'natural-orderby';
import TitleFilterNav from '../../../components/SmartScheduler/TitleFilterNav';
import placeholderImage from '../../../assets/images/placeholder.jpg';

const Navbar = ({ img, name }) => {
  const {
    selectedClientID,
    selectedSiteID,
    clientFilterHandler,
    siteFilterHandler,
  } = React.useContext(AppContext);
  const type = localStorage.getItem('type');
  const [activeClient, SetActiveClient] = useState(null);
  const [activeSite, setActiveSite] = useState(null);
  const [clients, setClients] = useState([]);
  const [sites, setSites] = useState([]);

  const fetchClients = async () => {
    let api_path = `/client/options`;
    let response = await newFetch(GET, api_path);

    if (response?.success) {
      const clientsData = orderBy(
        response.data.filter((client) => client.active === true),
        [(client) => client.name]
      ).map((client) => ({
        ...client,
        sites: orderBy(
          (client.sites || []).filter((site) => site.active === true),
          [(site) => site.name]
        ),
      }));
      localStorage.setItem('clientSiteOptions', JSON.stringify(clientsData));
      setClients(clientsData);

      if (clientsData.length === 0) {
        localStorage.setItem('client', 0);
        localStorage.setItem('site', 0);
        SetActiveClient(0);
        setActiveSite(0);
        setSites([]);
        selectedClientID != 0 && clientFilterHandler(0);
        selectedSiteID != 0 && siteFilterHandler(0);
        return;
      }

      const selectedClient =
        clientsData.find((client) => client.id == selectedClientID) ||
        clientsData[0];
      const validClientID = selectedClient.id;
      const sitesData = orderBy(
        (selectedClient.sites || []).filter((site) => site.active === true),
        [(site) => site.name]
      );
      const allSitesSelected =
        sitesData.length > 1 && Number(selectedSiteID) === 0;
      const selectedSite =
        sitesData.find((site) => site.id == selectedSiteID) || sitesData[0];
      const validSiteID = allSitesSelected
        ? 0
        : selectedSite
        ? selectedSite.id
        : 0;

      localStorage.setItem('client', validClientID);
      localStorage.setItem('site', validSiteID);
      SetActiveClient(validClientID);
      setActiveSite(validSiteID);
      setSites(sitesData);
      selectedClientID != validClientID && clientFilterHandler(validClientID);
      selectedSiteID != validSiteID && siteFilterHandler(validSiteID);
    }
  };

  const changeSiteHandler = (e) => {
    const siteID = e.target.value;
    setActiveSite(siteID);
    localStorage.setItem('site', siteID);
  };

  useEffect(() => {
    localStorage.getItem('access') && fetchClients();
  }, []);

  useEffect(() => {
    if (selectedSiteID !== null && selectedSiteID !== undefined) {
      setActiveSite(selectedSiteID);
    }
  }, [selectedSiteID]);

  return (
    <LayoutContext.Consumer>
      {({ sidebarToggleHandler }) => (
        <header className="app-header">
          {/* Sidebar toggle icon */}
          <button
            type="button"
            className="app-header-menu"
            onClick={sidebarToggleHandler}
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars"></i>
          </button>

          {/* Centered TitleFilterNav */}
          <div className="app-header-context">
            <TitleFilterNav
              options={clients}
              activeClient={activeClient}
              changeSite={changeSiteHandler}
              sites={sites}
              activeSite={activeSite}
              setSites={setSites}
              setActiveSite={setActiveSite}
            />
          </div>

          {/* Right-side items */}
          <div className="app-header-actions">
            {type !== 'client' && (
              <Link
                to="/notifications"
                className="app-header-icon"
                aria-label="Notifications"
              >
                <i className="fa fa-bell-o"></i>
              </Link>
            )}
            <div className="dropdown" id="dropdownMenuButton">
              <button
                className="app-profile dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={img}
                  alt="default"
                  className="app-profile-avatar"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = placeholderImage;
                  }}
                />

                <span
                  className="app-profile-copy"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <small>Welcome back</small>
                  <strong>{name}</strong>
                </span>
              </button>
              <div
                className="dropdown-menu dropdown-menu-end mt-2 p-2"
                aria-labelledby="dropdownMenuButton"
              >
                <Link to="/logout" className="dropdown-item adjust-fs">
                  <i className={`fa fa-sign-out me-2 text-muted`}></i>{' '}
                  <span className="text-muted">Logout</span>
                </Link>
              </div>
            </div>
          </div>
        </header>
      )}
    </LayoutContext.Consumer>
  );
};

export default Navbar;
